const ICONS = {
    QUESTION: 'pi pi-question',
    LINK: 'pi pi-sort-alt',
    LINK_INFO: 'pi pi-info-circle',
    INFO: 'pi pi-info-circle',
    GO: 'pi pi-angle-right',
    EXTERNAL_LINK: 'pi pi-external-link'
  };
  export { ICONS };